module.exports = __webpack_public_path__ + "images/wifiOff9f1753c587fc1df12ef292b63df38802.svg";